export const PERMS = {
    READ: 'vehicle_equipments.read',
    UPDATE: 'vehicle_equipments.update',
    DELETE: 'vehicle_equipments.delete',
    CREATE: 'vehicle_equipments.create',
    EXPORT: 'vehicle_equipments.export',
}
